import { Select, Text } from '@radix-ui/themes';
import { toast } from 'react-hot-toast';
import { useOrganization } from '../contexts/OrganizationContext';
import type { OrganizationOption } from '../contexts/OrganizationContext';

export type { OrganizationOption };

const OrganizationSelector: React.FC = () => {
  const { orgId, orgList, loading, setOrg } = useOrganization();

  const handleOrgChange = async (newOrgId: string) => {
    try {
      await setOrg(newOrgId);
      toast.success('Organization updated');
    } catch (error: any) {
      console.error('Failed to set organization:', error);
      toast.error(error?.message || 'Failed to set organization');
    }
  };

  if (loading || orgList.length === 0) {
    return null;
  }

  return (
    <Select.Root value={orgId} onValueChange={handleOrgChange}>
      <Select.Trigger className="cursor-pointer" placeholder="Select organization" />
      <Select.Content>
        {orgList.map((org) => (
          <Select.Item key={org.id} value={org.id}>
            <Text size="2">{org.name}</Text>
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default OrganizationSelector;
